<template>
  <section id="contact" class="contact section-show">
    <div class="container">
      <div class="section-title">
        <h2>اطلاعات ارتباطی شما</h2>
      </div>
      <form method="post" class="email-form mt-4" @submit="checkForm">
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="label">شماره همراه <img :src="star" /></label>
            <input
              id="mobile"
              type="text"
              class="form-control chmobile"
              @keypress="validateNumber"
              v-model="connection.mobile"
            />
            <p class="error" v-if="this.errors.mobile">
              <b>لطفا شماره همراه خود را وارد کنید</b>
            </p>
            <p class="error" v-if="this.errors.mobilelength">
              <b>لطفا 11 رقم وارد نمایید</b>
            </p>
            <label class="label">شماره ثابت</label>
            <input
              type="text"
              class="form-control"
              v-model="connection.phone"
              @keypress="validateNumber"
            />
            <label class="label">کدپستی</label>
            <input
              type="text"
              class="form-control"
              v-model="connection.zipCode"
              @keypress="validateNumber"
            />           
          </div>
          <div class="col-md-6 form-group mt-3 mt-md-0">
            <label class="label">آدرس ایمیل</label>
            <input
              type="text"
              class="form-control"
              v-model="connection.email"
            />
            <label class="label">استان <img :src="star" /></label>
            <Select2
              id="ostan"
              class="select-form"
              v-model="connection.ostanID"
              :options="ostan"
              :settings="{ width: '100%' }"
              @select="changeOstanItem($event)"
              placeholder="لطفا انتخاب کنید"
            />
            <p class="error" v-if="this.errors.ostan">
              <b>لطفا استان خود را انتخاب کنید</b>
            </p>
            <label class="label">شهر <img :src="star" /></label>
            <Select2
              id="city"
              class="select-form"
              v-model="connection.cityID"
              :options="city"
              :settings="{ width: '100%' }"
              @select="changeCityItem($event)"
              placeholder="لطفا انتخاب کنید"
            />
            <p class="error" v-if="this.errors.city">
              <b>لطفا شهر خود را انتخاب کنید</b>
            </p>
          </div>
          <div class="form-group mt-3">
            <label class="label">آدرس</label>
            <textarea
              class="form-control"
              name="message"
              rows="5"
              v-model="connection.address"
            ></textarea>
          </div>
        </div>
        <div class="text-center" style="margin-top: 20px">
          <button type="submit" class="btnsend">ثبت تغییرات</button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import star from "../assets/img/star.png";
import Select2 from "vue3-select2-component";
import { GetOstan, GetCity, UpdateContact, GetContact } from "@/API/API";
export default {
  name: "Identity",
  components: { Select2 },
  data() {
    return {
      star,
      connection: {},
      ostan: [],
      city: [],
      errors: {
        mobile: "",
        mobilelength: "",
        ostan: "",
        city: "",
        zipcodelength: "",
        length: 0,
      },
    };
  },
  async created() {
    this.connection = (await GetContact(this.$store.getters.seq)).data.result;
    this.ostan = (await GetOstan()).data.result;
    let oid = this.connection.ostanID;
    if (oid == null || oid == 0) {
      this.city = (await GetCity(0)).data.result;
    }
    this.city = (await GetCity(oid)).data.result;
  },
  methods: {
    validateNumber: (event) => {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    async changeOstanItem({ id }) {
      this.connection.ostanID = id;
      this.city = (await GetCity(id)).data.result;
    },
    changeCityItem({ id }) {
      this.connection.cityID = id;
    },
    checkForm: function (e) {
      console.log(this.connection)
      console.log(this.connection.cityID);
      e.preventDefault();
      this.errors = [];

      if (!this.connection.mobile) {
        this.errors.mobile = true;
        this.errors.length += 1;
      }
      if (
        this.connection.mobile.toString().length != 11 &&
        this.connection.mobile.toString().length != 0
      ) {
        this.errors.mobilelength = true;
        this.errors.length += 1;
      }
      if (this.connection.ostanID <= 0 || this.connection.ostanID == null) {
        this.errors.ostan = true;
        this.errors.length += 1;
      }
      if (this.connection.cityID <= 0 || this.connection.cityID == null) {
        this.errors.city = true;
        this.errors.length += 1;
      }
      if (this.errors.length == 0) {
        this.connection.ostanID = parseInt(this.connection.ostanID);
        this.connection.cityID = parseInt(this.connection.cityID);
       

        UpdateContact(this.connection)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "ویرایش باموفقیت انجام شد",
              confirmButtonColor: "#1e682d",
              confirmButtonText: "باشه",
            });
          })
          .catch(() => {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "عملیات باشکست مواجه شد",
              confirmButtonColor: "#900C3F",
              confirmButtonText: "باشه",
            });
          });
      }
    },
  },
};
</script>
<style scoped>
.section-title h2 {
  font-size: 18px;
  font-weight: 700;
  padding: 0;
  line-height: 18px;
  margin: 30px 0 20px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #111;
  font-family: "iransans", Lato, sans-serif;
  padding-bottom: 15px;
  position: relative;
}
.section-title h2::after {
  content: "";
  width: 190px;
  height: 2px;
  background: #d1a44f;
  bottom: 0;
  top: auto;
  position: absolute;
  right: 0;
}
</style>
